import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import api from "../../../api/Api.js";
import { Link, useParams, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Swal from "sweetalert2";

const EditStatePage = () => {
  const { stateId } = useParams();
  const navigate = useNavigate();

  // =========================================
  // STATES
  // =========================================

  const [getCategoryName, setCategoryName] = useState("");
  const [getCategorySlug, setCategorySlug] = useState("");

  const [getCategoryMeta_title, setCategoryMeta_title] = useState("");
  const [getCategoryMeta_desc, setCategoryMeta_desc] = useState("");
  const [getCategoryMeta_keyword, setCategoryMeta_keyword] = useState("");
  const [getCategoryPage_desc, setCategoryPage_desc] = useState("");
 const [getState, setState] = useState([]);
 const [state_id,setstate_id] = useState("");
  const [isLoading, setIsLoading] = useState(false);
const [loadingStates, setLoadingStates] = useState(false);
  // =========================================
  // GENERATE SLUG
  // =========================================

  const generateSlug = (value) => {
    return value
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
  };
  
    const fetchCountryData = async () => {
    try {
      setLoadingStates(true);

      const res = await api.get(
        "/adminHolidays/get-holidays-country-data"
      );

      const stateData = res.data?.data;

      setState(
        Array.isArray(stateData) ? stateData : []
      );
    } catch (error) {
      console.error("Fetch State Error =>", error);

      toast.error("Failed to load State Name data");
      setState([]);
    } finally {
      setLoadingStates(false);
    }
  };

  useEffect(() => {
    fetchCountryData();
  }, []);

  // =========================================
  // FETCH SINGLE STATE
  // =========================================

  const fetchStateById = async () => {
    try {
      setIsLoading(true);

      const res = await api.get(
        `/adminHolidays/get-holidays-state-by-id/${stateId}`
      );

      console.log("STATE DATA =>", res.data);

      if (res.data.success) {
        const data = res.data.data;

        setCategoryName(data?.state || "");
        setCategorySlug(data?.slug || "");

        setCategoryMeta_title(data?.meta_title || "");
        setCategoryMeta_desc(data?.meta_desc || "");
        setCategoryMeta_keyword(data?.meta_keyword || "");
        setCategoryPage_desc(data?.page_desc || "");
        setstate_id(data?.cntry_id || "");
      } else {
        toast.error(
          res.data.message || "State Name not found"
        );
      }
    } catch (error) {
      console.error("FETCH STATE ERROR =>", error);

      toast.error(
        error?.response?.data?.message ||
          "Failed to fetch State Name"
      );
    } finally {
      setIsLoading(false);
    }
  };

  // =========================================
  // FETCH DATA
  // =========================================

  useEffect(() => {
    if (stateId) {
      fetchStateById();
    }
  }, [stateId]);

  // =========================================
  // AUTO GENERATE SLUG
  // =========================================
  //
  // Important:
  // Slug will change when user changes State Name.
  //
  // But during initial API fetch, we don't want
  // the fetched database slug to be unnecessarily
  // changed.
  //
  // =========================================

  const handleNameChange = (e) => {
    const value = e.target.value;

    setCategoryName(value);
    setCategorySlug(generateSlug(value));
  };

  // =========================================
  // UPDATE STATE
  // =========================================

 const updateCategory = async () => {
  // =========================================
  // VALIDATION
  // =========================================

  if (!getCategoryName.trim()) {
    toast.error("State Name required");
    return;
  }

  if (!getCategorySlug.trim()) {
    toast.error("State Slug required");
    return;
  }

  // =========================================
  // CONFIRMATION
  // =========================================

  const confirm = await Swal.fire({
    title: "Update State Name?",
    text: "Do you want to update this State?",
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Yes Update",
    cancelButtonText: "Cancel",
  });

  if (!confirm.isConfirmed) {
    return;
  }

  try {
    setIsLoading(true);

    // =========================================
    // PAYLOAD
    // =========================================

    const payload = {
      category: getCategoryName.trim(),
      cntry_id: state_id,
      slug: getCategorySlug.trim(),
      meta_title: getCategoryMeta_title.trim(),
      meta_desc: getCategoryMeta_desc.trim(),
      meta_keyword: getCategoryMeta_keyword.trim(),
      page_desc: getCategoryPage_desc.trim(),
    };

    console.log("UPDATE STATE PAYLOAD =>", payload);

    // =========================================
    // API
    // =========================================

    const res = await api.put(
      `/adminHolidays/holidays-update-state/${stateId}`,
      payload
    );

    console.log("UPDATE STATE RESPONSE =>", res.data);

    // =========================================
    // SUCCESS
    // =========================================

    if (res.data.success) {
      await Swal.fire({
        title: "Success",
        text: "State Updated Successfully",
        icon: "success",
        confirmButtonText: "OK",
      });

      navigate("/holidays/state/manage-state");
    } else {
      Swal.fire({
        title: "Error",
        text:
          res.data.message ||
          "Unable to update State",
        icon: "error",
      });
    }

  } catch (error) {
    console.error(
      "UPDATE STATE ERROR =>",
      error
    );

    console.error(
      "RESPONSE =>",
      error?.response?.data
    );

    toast.error(
      error?.response?.data?.message ||
      "Server Error"
    );

  } finally {
    setIsLoading(false);
  }
};

   const handleNameState = (e) => {
    const value = e.target.value;
    setstate_id(value);
  };

  // =========================================
  // UI
  // =========================================

  return (
    <div className="container-fluid py-3 bg-white min-vh-100">

      {/* =========================================
          HEADER
      ========================================= */}

      <div className="card shadow-sm mb-4 bg-primary-subtle">
        <div className="card-body d-flex justify-content-between align-items-center">
          <h4 className="mb-0">
            Edit State Name
          </h4>

          <Link
            to="/holidays/state/manage-state"
            className="btn btn-secondary btn-sm d-flex align-items-center gap-1"
          >
            <ArrowLeft size={16} />
            Back
          </Link>
        </div>
      </div>

      {/* =========================================
          FORM
      ========================================= */}

      <div className="card">
        <div className="card-body">

          <table className="table table-bordered">

            {/* =====================================
                STATE NAME / SLUG
            ===================================== */}

            <thead>
              <tr>
                <th>Country Name</th>
                    <th>
                <div className="row">
                  <div className="col-md-6 col-lg-6">
State Name
                  </div>
                    <div className="col-md-6 col-lg-6">
                    Slug
                  </div>
                </div>
            </th>
              </tr>
            </thead>

            <tbody>
              <tr>

                {/* STATE NAME */}

                 <td style={{width:"50%"}}>
                
                  <select
                        className="form-select"
                        value={state_id}
                        disabled={loadingStates}
                       onChange={handleNameState}
                      >
                        <option value="">
                          {loadingStates
                            ? "Loading Country..."
                            : "- Select Country -"}
                        </option>

                        {getState.map((cat) => (
                          <option
                            key={cat.cntry_id}
                            value={cat.cntry_id}
                          >
                            {cat.name}
                          </option>
                        ))}
                      </select>
                </td>


  <th>
                <div className="row">
                  <div className="col-md-6 col-lg-6">
 <input
                    type="text"
                    className="form-control"
                    value={getCategoryName}
                    onChange={handleNameChange}
                    placeholder="Enter State Name"
                  />
                  </div>
                    <div className="col-md-6 col-lg-6">
                      <input
                    type="text"
                    className="form-control"
                    value={getCategorySlug}
                    readOnly
                  />

                  <small className="text-muted">
                    Slug is generated automatically
                  </small>
                  </div>
                </div>
            </th>

                {/* SLUG */}


              </tr>
            </tbody>

            {/* =====================================
                META TITLE / META DESCRIPTION
            ===================================== */}

            <thead>
              <tr>

                <th>
                  <div className="d-flex align-items-center gap-2">
                    <span>Meta Title</span>

                    <small
                      className={
                        (getCategoryMeta_title?.length || 0) >
                        80
                          ? "text-danger"
                          : "text-muted"
                      }
                    >
                      (
                      {getCategoryMeta_title?.length || 0}
                      /80 Characters)
                    </small>
                  </div>
                </th>

                <th>
                  <div className="d-flex align-items-center gap-2">
                    <span>Meta Description</span>

                    <small
                      className={
                        (getCategoryMeta_desc?.length || 0) >
                        160
                          ? "text-danger"
                          : "text-muted"
                      }
                    >
                      (
                      {getCategoryMeta_desc?.length || 0}
                      /160 Characters)
                    </small>
                  </div>
                </th>

              </tr>
            </thead>

            <tbody>
              <tr>

                {/* META TITLE */}

                <td>
                  <textarea
                    rows="3"
                    className="form-control"
                    maxLength={80}
                    value={getCategoryMeta_title}
                    onChange={(e) =>
                      setCategoryMeta_title(
                        e.target.value
                      )
                    }
                    placeholder="Enter Meta Title"
                  />

                  {(getCategoryMeta_title?.length || 0) >=
                    79 && (
                    <small className="text-danger">
                      ⚠️ Almost reached limit
                    </small>
                  )}
                </td>

                {/* META DESCRIPTION */}

                <td>
                  <textarea
                    rows="3"
                    className="form-control"
                    maxLength={160}
                    value={getCategoryMeta_desc}
                    onChange={(e) =>
                      setCategoryMeta_desc(
                        e.target.value
                      )
                    }
                    placeholder="Enter Meta Description"
                  />

                  {(getCategoryMeta_desc?.length || 0) >=
                    159 && (
                    <small className="text-danger">
                      ⚠️ Almost reached limit
                    </small>
                  )}
                </td>

              </tr>
            </tbody>

            {/* =====================================
                META KEYWORD / PAGE DESCRIPTION
            ===================================== */}

            <thead>
              <tr>

                <th>
                  <div className="d-flex align-items-center gap-2">
                    <span>Meta Keyword</span>

                    <small
                      className={
                        (getCategoryMeta_keyword?.length ||
                          0) > 255
                          ? "text-danger"
                          : "text-muted"
                      }
                    >
                      (
                      {getCategoryMeta_keyword?.length ||
                        0}
                      /255 Characters)
                    </small>
                  </div>
                </th>

                <th>Page Description</th>

              </tr>
            </thead>

            <tbody>
              <tr>

                {/* META KEYWORD */}

                <td>
                  <textarea
                    rows="3"
                    maxLength={255}
                    className="form-control"
                    value={getCategoryMeta_keyword}
                    onChange={(e) =>
                      setCategoryMeta_keyword(
                        e.target.value
                      )
                    }
                    placeholder="Enter Meta Keywords"
                  />

                  {(getCategoryMeta_keyword?.length ||
                    0) >= 254 && (
                    <small className="text-danger">
                      ⚠️ Almost reached limit
                    </small>
                  )}
                </td>

                {/* PAGE DESCRIPTION */}

                <td>
                  <textarea
                    rows="3"
                    className="form-control"
                    value={getCategoryPage_desc}
                    onChange={(e) =>
                      setCategoryPage_desc(
                        e.target.value
                      )
                    }
                    placeholder="Enter Page Description"
                  />
                </td>

              </tr>
            </tbody>

          </table>

          {/* =========================================
              UPDATE BUTTON
          ========================================= */}

          <button
            type="button"
            className="btn btn-success mt-3"
            onClick={updateCategory}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>

                Updating...
              </>
            ) : (
              "Update State Name"
            )}
          </button>

        </div>
      </div>
    </div>
  );
};

export default EditStatePage;